import ViewIconButton from "gui/components/viewIconButton/ViewIconButton";
import React from "react";
import styles from './FilesSelectedState.module.scss';
import {saveAs} from 'file-saver';
import fileSize from 'filesize';

interface extendedFile extends File {
  document_id?: string;
  id?: string;
}

export interface IFilesSelectedStateProps {
  files: extendedFile[];
  downloadFile?: any;
}

enum FILE_SIZE {
  _1MB = 1000000,
  _50MB = FILE_SIZE._1MB * 50,
}

const FilesSelectedState = (props: IFilesSelectedStateProps) => {
  if (props.files.length > 0) {
    if (props.files.length > 1) {
      return <div>
        <span>נבחרו</span>
        {' '}
        <span>{props.files.length}</span>
        {' '}
        <span>קבצים</span>
      </div>;
    } else {
      const file = props.files[0];
      return <div className={styles.selectedState}>
        <span>נבחר קובץ</span>
        <ViewIconButton onClick={() => {
          if (file.document_id && file.id && props.downloadFile) {
            props.downloadFile(file.id);
          } else {
            saveAs(file);
          }
        }}/>
        <small
          className={`${styles.fileSize2} ${file.size > FILE_SIZE._50MB ? styles.overLimit : ''}`.trim()}>{fileSize(file.size)}</small>
      </div>;
    }
  }
  return <div className={styles.selectedState}>
    <small className={styles.fileTypes}>JPG,PNG,DOC,DOCX,PDF,XPS</small>
    <small className={styles.fileSize}>50MB</small>
  </div>;
}

FilesSelectedState.defaultProps = {
  setState: () => {
  },
  options: [],
};

export default FilesSelectedState;
